exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* purgecss start ignore */\n.save-story-btn[data-v-c98666a8] {\n  background-color: #e30613;\n  box-shadow: 0 0 3px 0 #b70912;\n  color: #fff;\n  padding: 8px 0;\n  width: 100px;\n}\n\n/* purgecss end ignore */\n", ""]);

// exports
